import { render, staticRenderFns } from "./WorkRegimeHistoryButton.vue?vue&type=template&id=288dd779&scoped=true"
import script from "./WorkRegimeHistoryButton.vue?vue&type=script&lang=js"
export * from "./WorkRegimeHistoryButton.vue?vue&type=script&lang=js"
import style0 from "./WorkRegimeHistoryButton.vue?vue&type=style&index=0&id=288dd779&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288dd779",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('288dd779')) {
      api.createRecord('288dd779', component.options)
    } else {
      api.reload('288dd779', component.options)
    }
    module.hot.accept("./WorkRegimeHistoryButton.vue?vue&type=template&id=288dd779&scoped=true", function () {
      api.rerender('288dd779', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/WorkRegimeHistoryButton.vue"
export default component.exports